module.exports = __webpack_public_path__ + "img/fresherCoin.a5e690cf.svg";